import {MegaOptionInterface} from "@/types/MegaOption";
import {NamedOption} from "@/util/NamedOption";


export class MegaOption extends NamedOption implements MegaOptionInterface{
  focus: string;
  title: string;

  constructor(text: string, value: string | number | boolean, name: string, focus: string, title: string) {
    super(text, value, name);
    this.focus = focus;
    this.title = title;
  }
}
